import { useQuery } from '@tanstack/react-query';
import { http } from 'services/http';
import { WH_PERFORMANCE_STATISTICS_GET } from 'api/query-keys';
import type { TWarehousePerformanceRes } from 'api/swagger';
import type { IWhPerformanceFilter } from 'shared/stores/use-wh-performance-filters';
import { setFiltersToQs } from 'shared/utils/filters/set-filters-to-qs';

interface IParams {
  filters: IWhPerformanceFilter;
}

export const useGetWhPerformanceStatistics = ({ filters }: IParams) => {
  const qs = new URLSearchParams();
  setFiltersToQs<IWhPerformanceFilter>(qs, filters);

  return useQuery({
    queryKey: [WH_PERFORMANCE_STATISTICS_GET, { filters }],
    queryFn: async () => {
      const { data } = await http.get<TWarehousePerformanceRes>(
        `/v1/statistics/warehouse-performance?${qs.toString()}`,
      );
      return data;
    },
    retry: false,
    refetchOnWindowFocus: false,
    enabled: !!filters.date,
  });
};
